import React from 'react';
// component
import LrfForm from '../../Container/LRFForm'
// styles
import LoginStyle from "./style";
// images
import Background from '../../Assets/background.svg'

function Login() {
    return (
        <>
            <div className='d-flex'>
                <div className='login-left-wrap green-background'>
                    <img src={Background} alt='Background'/>
                </div>
                <LrfForm />
            </div>
            <LoginStyle/>
        </>
    )
}

export default Login;